import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '../card/card';
import Slug from '../slug/slug';
import PromoBanner from '../promo_banner/promo_banner';

export default class Column extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (!this.props) {
      return null;
    }

    const { className, stories, slugName, slugLink, promoBanner } = this.props;

    const hasPromoBannerData = get(promoBanner, 'image_url');
    return (
      <div
        className={`column-component control ${className || 'card-wrapper--3'}`}
      >
        {hasPromoBannerData ? <PromoBanner {...promoBanner} /> : ''}
        {slugName
          ? <Slug linkTo={slugLink} slugName={slugName} className="column" />
          : ''}
        <div
          className={
            hasPromoBannerData ? 'scroll-me scroll-me--promoting' : 'scroll-me'
          }
        >
          {stories.map(item =>
            <Card
              className={className}
              metadata={item}
              key={item.id}
              columnCard
            />
          )}
        </div>
      </div>
    );
  }
}

Column.defaultProps = {
  className: '',
  slugName: '',
  slugLink: '',
  promoBanner: null
};

Column.propTypes = {
  className: PropTypes.string,
  slugName: PropTypes.string,
  slugLink: PropTypes.string,
  stories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  promoBanner: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/column/column.js